// Exports:
export default async (URL) => URL ? (await fetch(URL, { 'mode':'no-cors' })).type === 'opaque' : false
